export default __webpack_public_path__ + "assets/50e9e7b70fcf31cb234f2e2a8e660cd5.jpeg";